export default defineNuxtPlugin(async (nuxtApp) => {
	nuxtApp.provide('screen', useScreen())
	const c = useAppConfig()
	if (c.gsmaterials?.apiData) {
		for (const key of Object.keys(c.gsmaterials.apiData)) {
			if (c.gsmaterials.apiData[key].preload)
				await useDataResolver(key)
		}
	}
})
